import { Button } from '@cambridgeassessment/cambridge-ui';
import { NavigateBeforeRounded } from '@material-ui/icons';
import React, { memo } from 'react';
import { useHistory } from 'react-router-dom';
import { useGoBackButton } from './styles';

const GoBackButton: React.FC = () => {
  const classes = useGoBackButton();
  const history = useHistory();

  return (
    <Button
      className={classes.button}
      style={{ color: '#00588f' }}
      tabIndex={0}
      data-testid="back-link"
      onClick={() => history.goBack()}
      variant="text"
      size="small"
    >
      <NavigateBeforeRounded /> Go back
    </Button>
  );
};

export default memo(GoBackButton);
